import { KeyboardBindType } from "@1games-ru/region-shared/dist/enums/account/settings";
import { isEmpty } from "lodash";
import { AnimatePresence, motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";
import useAppSelector from "@/core/helpers/useAppSelector";
import { keyCodeLabel } from "@/shared/constants/keyCodeLabel";
import { activeKeySelector } from "@/domains/activeKey/slice";
import { isShowSelector, showTipLabelSelector, useHudStore } from "@/domains/hud/store";
import useHintsValues from "@/domains/hud/hooks/useHintValues";
import useShowHints from "@/domains/hud/hooks/useShowHints";
import HudHint from "@/domains/hud/components/HudHint";
import { controlSettingsSelector } from "@/domains/settings/control/slice";

export default function HudHintsContainer() {
  const { isShowHints } = useShowHints();
  const { t } = useTranslation("hud");
  const { hintValues } = useHintsValues();
  const showTipLabel = useHudStore(showTipLabelSelector);
  const activeKey = useAppSelector(activeKeySelector);
  const controlSettings = useAppSelector(controlSettingsSelector);

  if (isEmpty(controlSettings)) return null;

  return (
    <div className={cn("relative flex flex-col items-end")}>
      <AnimatePresence>
        {isShowHints ? (
          <motion.div
            key="hints"
            className="flex flex-col gap-0.5 items-end"
            initial={{ opacity: 0, translateY: "5rem" }}
            animate={{ opacity: 1, translateY: "none" }}
            exit={{ opacity: 0, translateY: "5rem" }}
            transition={{ bounce: false }}
          >
            {hintValues.map((item) => (
              <HudHint
                key={item.value + item.label}
                char={item.char}
                label={item.label}
                showLabel={showTipLabel}
                isActive={activeKey === item.value}
              />
            ))}
          </motion.div>
        ) : (
          <motion.div
            key="toggle"
            className=""
            initial={{ opacity: 0, translateY: "5rem" }}
            animate={{ opacity: 1, translateY: "none" }}
            exit={{ opacity: 0, translateY: "5rem" }}
            transition={{ bounce: false }}
          >
            <HudHint
              char={keyCodeLabel[controlSettings[KeyboardBindType.TOGGLE_HINTS].key]}
              label={t("hud.showHints")}
              showLabel={showTipLabel}
              isActive={activeKey === controlSettings[KeyboardBindType.TOGGLE_HINTS].key}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
